export const SELECT_ALL_VALUES_OPTION = {
  label: 'Todos',
  value: 'TODOS',
};
